export const scannedRecentlyStyles = ({
  iconContainer: {
    position: "relative"
  },
  mobileIcon: {
    marginTop: 75,
    marginLeft: "50%",
    transform: "translateX(-50%)"
  },
  errorIcon: {
    position: "absolute",
    marginTop: 75,
    left: "50%",
    transform: "translate(-50%, -40%)"
  } as const
});